import { render, staticRenderFns } from "./AveragePrice.vue?vue&type=template&id=4e507194&scoped=true&"
import script from "./AveragePrice.vue?vue&type=script&lang=js&"
export * from "./AveragePrice.vue?vue&type=script&lang=js&"
import style0 from "./AveragePrice.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./AveragePrice.vue?vue&type=style&index=1&id=4e507194&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e507194",
  null
  
)

export default component.exports